// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"A4-z","upvote":"B4-z","downvote":"C4-z","numVotes":"D4-z","votesDescription":"E4-z","report":"F4-z","voted":"G4-z","answerVoteBox":"H4-z","justReported":"I4-z"};